window.SwymCallbacks = window.SwymCallbacks || [];

const scheduleNextCheckWishlist = (exclusiveAccesses) => {
  const callback = () => {
    updateAccessesStatusWishlist(exclusiveAccesses);
  };
  scheduleNextCheck(exclusiveAccesses, callback);
};

const updateAccessesStatusWishlist = (exclusiveAccesses) => {
  const $wishListItem = document.querySelectorAll(
    `.swym-wishlist-item[aria-labelledby="${exclusiveAccesses.product.title}"]`
  );

  const updatedAccesses = updateAccessesStatus(exclusiveAccesses);
  const hasAccess = updatedAccesses.hasAccess;

  if ($wishListItem.length) {
    $wishListItem.forEach((item) => {
      const $addToCartButton = item.querySelector('.swym-add-to-cart-btn');
      if (hasAccess) {
        $addToCartButton.removeAttribute('disabled');
        $addToCartButton.classList.remove('swym-disabled');
      } else {
        $addToCartButton.setAttribute('disabled', true);
        $addToCartButton.classList.add('swym-disabled');
      }
    });
  }
};

let getExclusiveAccessData = async function (productUrl) {
  // Construct the URL to fetch the product data
  // Assuming 'product.url' is a valid URL path to the product
  let url = productUrl + '?sections=template--17310088659197__main';

  try {
    const response = await fetch(url);
    const data = await response.json();
    // Check if the specific template data is available
    if (data['template--17310088659197__main']) {
      // Create a temporary div to parse the HTML response
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data['template--17310088659197__main'];

      // Check if the metafields data is present in the response
      // Ensure the selector is correctly closed with ']'
      if (tempDiv.querySelector('[data-exclusive-accesses-json]')) {
        const exclusiveAccesses = JSON.parse(
          tempDiv.querySelector('[data-exclusive-accesses-json]').innerHTML
        );

        updateAccessesStatusWishlist(exclusiveAccesses);
        scheduleNextCheckWishlist(exclusiveAccesses);
      }
    }
  } catch (error) {
    console.error('Error constructing URL', error);
  }
};

// Define success callback
let onSuccess = async function (lists) {
  // Successfully fetched all lists
  for (const list of lists) {
    for (const product of list.listcontents) {
      await getExclusiveAccessData(product.du);
    }
  }
};

// Define error callback
let onError = function (error) {
  // Error is an xhrObject
  console.log('Error while fetching all Lists', error);
};

window.SwymCallbacks.push(function (swat) {
  swat.fetchLists({
    callbackFn: onSuccess,
    errorFn: onError,
  });
});

window.SwymCallbacks.push(function (swat) {
    document.addEventListener("swym:collections-loaded", function() {
        swat.initializeActionButtons(".product-grid");
        swat.initializeActionButtons(".predictive-search-results__products");
    })
});